export default class SupportActivityService {
    constructor(http) {
        this.http = http;
    }

    sendEvent(supportEvent) {
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/support', supportEvent).then(
                (response) => {
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }
}


// WEBPACK FOOTER //
// ./src/service/supportActivity.js